import { Link } from '@remix-run/react'
import React from 'react'
import frameImage from '/img/LinkCards/Frame_fondo.png'
import { EXTERNAL_LINK_PROPS } from '#app/shared/lib/external-links.ts'
import { Spacer } from '#app/shared/ui/data-display/Spacer.tsx'
import { Button } from '#app/shared/ui/inputs/button/Button.tsx'

interface LinkCardProps {
  image: string
  title: string
  description: string
  buttonText: string
  footerText?: string
  backgroundColor?: string
  withFrame?: boolean
  textColor?: string
  footerTextColor?: string
  buttonLink?: string
  isLast?: boolean
}

const LinkCard: React.FC<LinkCardProps> = ({
  image,
  title,
  description,
  buttonText,
  footerText,
  withFrame = true,
  buttonLink = '#',
  isLast,
}) => {
  return (
    <div
      className={`
        w-full

        lg:w-[320px] lg:px-0

        sm:w-[calc(50%-8px)] sm:px-0
      `}
    >
      <div
        className={`
          relative h-[434px] w-full max-w-full overflow-hidden rounded-[8px]

          lg:max-w-[320px]

          sm:h-[457px]
        `}
      >
        <div
          className={`
            h-full w-full

            ${isLast ? '' : 'bg-neutral-75'}
          `}
        >
          <div
            className={`
              relative z-10 p-6 px-7

              lg:px-10
            `}
          >
            {title === 'Aceptamos tu coche como parte del pago' && (
              <Spacer size="24px" />
            )}
            <div className="mt-5 flex items-center justify-center">
              {/* the css of the image is so that in mobile the image is adapted to the width of the card and in desktop the image is static */}
              <img
                src={image}
                alt={title}
                className={`
                  max-w-none

                  ${
                    title === 'Aceptamos tu coche como parte del pago'
                      ? `
                        absolute left-1/2 top-[15%] w-full -translate-x-1/2

                        lg:!static lg:translate-none lg:w-auto lg:max-w-none
                        lg:-translate-x-0 lg:object-contain
                      `
                      : 'object-contain'
                  }
                `}
              />
            </div>
            {/* as the image is absolute so it can adapts to the card, we need put some space to avoid that the text is on top of the image */}
            {title === 'Aceptamos tu coche como parte del pago' && (
              <Spacer size="128px" className="lg:hidden" />
            )}
            <p
              className={`
                mt-7 text-center font-saira text-h4 leading-tight
                text-neutral-800
              `}
            >
              {title}
            </p>
            {description && (
              <p
                className={`
                  mt-4 text-center font-saira text-h5-medium text-neutral-600
                `}
              >
                {description}
              </p>
            )}
            <div className="mt-5 flex justify-center">
              {/* `buttonLink` puede apuntar a una app externa (p. ej. "Encarga
                  un coche"), que no la puede resolver el router de Remix. */}
              {buttonLink.startsWith('http') ? (
                <a href={buttonLink} {...EXTERNAL_LINK_PROPS}>
                  <Button className="font-saira font-normal">
                    {buttonText}
                  </Button>
                </a>
              ) : (
                <Link to={buttonLink}>
                  <Button className="font-saira font-normal">
                    {buttonText}
                  </Button>
                </Link>
              )}
            </div>
            {footerText && (
              <p
                className={`
                  mt-4 text-center font-saira text-subtitle1-medium
                  text-neutral-600
                `}
              >
                {footerText}
              </p>
            )}
          </div>
        </div>
        {withFrame && (
          <img
            src={frameImage}
            alt="Frame"
            className="absolute inset-0 z-0 h-full w-full object-cover"
          />
        )}
      </div>
    </div>
  )
}

export default LinkCard
